// referencing from https://github.com/kmturley/touch-scroll/blob/master/js/TouchScroll.js

export default class TouchScroll {
  constructor ($el, options) {
    this.drag = false
    this.time = 0.04

    this.start = 1
    this.el = null
    this.wait = true

    this.startx = 0
    this.starty = 0
    this.diffx = 0
    this.diffy = 0

    this.requestAnimate = null
    this.el = $el
    this.wait = options.wait

    if (options.draggable === true) {
      const isIE = window.navigator.userAgent.toLowerCase().indexOf('msie') > -1
      if (isIE) {
        document.ondragstart = function () { return false }
      }

      addEvent('mousedown', this.el, e => this.onMouseDown(e))
      addEvent('mousemove', this.el, e => this.onMouseMove(e))
      addEvent('mouseup', this.el, e => this.onMouseUp(e))
    }
  }

  onMouseDown = e => {
    if (this.requestAnimate) {
      cancelAnimationFrame(this.requestAnimate)
      this.requestAnimate = null
    }
    if (this.drag === false || this.wait === false) {
      // ignore mousedown event if emitted on scrollbar
      this.drag = e.offsetX <= e.target.clientWidth && e.offsetY <= e.target.clientHeight
      cancelEvent(e)
      this.startx = e.clientX + this.el.scrollLeft
      this.starty = e.clientY + this.el.scrollTop
      this.diffx = 0
      this.diffy = 0
    }
  }

  onMouseMove = e => {
    if (this.drag === true) {
      cancelEvent(e)
      this.diffx = (this.startx - (e.clientX + this.el.scrollLeft))
      this.diffy = (this.starty - (e.clientY + this.el.scrollTop))
      this.el.scrollLeft += this.diffx
      this.el.scrollTop += this.diffy
    }
  }

  onMouseUp = e => {
    if (this.drag === true) {
      if (!this.wait) {
        this.drag = null
      }
      cancelEvent(e)
      this.start = 1
      this.animate()
    }
  }

  animate = () => {
    var step = Math.sin(this.start)
    if (step <= 0) {
      this.diffx = 0
      this.diffy = 0
      cancelAnimationFrame(this.requestAnimate)
      this.requestAnimate = null
      // if (!this.drag) {
      // }
      this.drag = false
    } else {
      this.el.scrollLeft += this.diffx * step
      this.el.scrollTop += this.diffy * step
      this.start -= this.time
      this.requestAnimate = requestAnimationFrame(() => this.animate())
    }
  }
}

const addEvent = (name, el, func) => {
  if (el.addEventListener) {
    el.addEventListener(name, func, false)
  } else if (el.attachEvent) {
    el.attachEvent('on' + name, func)
  } else {
    el[name] = func
  }
}

const cancelEvent = e => {
  if (!e) { e = window.event }
  if (e.target && e.target.nodeName === 'IMG') {
    e.preventDefault()
  } else if (e.srcElement && e.srcElement.nodeName === 'IMG') {
    e.returnValue = false
  }
}
